export { default } from './part-lazy-image';
